import React, {PropsWithChildren, useEffect, useState} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, KTSVG} from '../../../helpers'
import {useLayout, usePageData} from '../../core'
import {PAGE_PERMISSION} from '../../../../app/modules/roles/constant/role-default'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  pagePermission?: PAGE_PERMISSION | null
  hasBullet?: boolean
}

const AsideMenuItem: React.FC<PropsWithChildren<Props>> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  pagePermission = null,
  hasBullet = false,
}) => {
  const {pathname} = useLocation()
  const isActive = checkIsActive(pathname, to)
  const {config} = useLayout()
  const {aside} = config
  const [canView, setCanView] = useState(true)
  const {
    currentUser: {activePages},
  } = usePageData()

  useEffect(() => {
    if (!!pagePermission) {
      const allowed = activePages.some((page) => page.name === pagePermission)
      setCanView(allowed)
    }
  }, [pagePermission, activePages])

  if (!canView) return <> </>

  return (
    <div className='menu-item'>
      <Link className={clsx('menu-link without-sub', {active: isActive})} to={to}>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && aside.menuIcon === 'svg' && (
          <span className='menu-icon'>
            <KTSVG path={icon} className='svg-icon-2' />
          </span>
        )}
        {fontIcon && aside.menuIcon === 'font' && <i className={clsx('bi fs-3', fontIcon)}></i>}
        <span className='menu-title'>{title}</span>
      </Link>
      {children}
    </div>
  )
}

export {AsideMenuItem}
